{
  "general": {
    "title": "Titre"
  },
  "header": {
    "language": "Langue",
    "help": "Aide",
    "help_modal": {
      "description": "Si vous avez besoin d'assistance ou si vous avez des questions, vous pouvez nous contacter par e-mail à {mail} ou par téléphone au {phone}."
    }
  },
  "fields": {
    "error_message": "Ce champ est requis",
    "invalid_email": "Adresse e-mail invalide",
    "invalid_end": "L'heure de fin doit être postérieure à l'heure de début",
    "terms_required": "Vous devez accepter les conditions générales pour continuer",
    "invalid_phone": "Numéro de téléphone invalide. Essayez d'ajouter l'indicatif du pays",
    "function_space_required": "Veuillez sélectionner un espace de réception pour continuer",
    "function_space_configuration_error": "Aucun espace de réception ne peut accueillir votre configuration sélectionnée. Veuillez ajuster le nombre d'invités ou le type de disposition.",
    "function_space_date_unavailable": "Les espaces de réception qui correspondent à vos exigences ne sont pas disponibles à la date sélectionnée. Veuillez choisir une autre date.",
    "function_space_conflict_error": "Cet espace de fonction est déjà sélectionné pour une période qui se chevauche. Veuillez choisir un autre espace ou ajuster l'heure."
  },
  "reservation_steps": {
    "title": "Votre Réservation :",
    "step_1": {
      "title": "Détails De La Réservation",
      "sub_steps": {
        "services": "Services Requis",
        "location": "Choisissez un Établissement",
        "email": "Coordonnées"
      }
    },
    "step_2": {
      "title": "Espaces Événementiels",
      "sub_steps": {
        "basic_information_meeting_rooms": "Votre événement",
        "days": "Détails De L'Événement",
        "remarks": "Remarques"
      }
    },
    "step_3": {
      "title": "Chambres",
      "title_with_date": "Chambres pour {date}",
      "sub_steps": {
        "basic_information_hotel_rooms": "Détails"
      }
    },
    "step_4": {
      "title": "Coordonnées",
      "sub_steps": {
        "basic_information": "Informations Sur Le Compte",
        "contact_person": "Adresse De Facturation"
      }
    },
    "step_5": {
      "title": "Récapitulatif De La Réservation"
    }
  },
  "reservation_form": {
    "step_1": {
      "services": {
        "title": "Services Requis",
        "mice": "Espaces Pour Événements",
        "hotel": "Chambres"
      },
      "location": {
        "title": "Choisissez un Établissement",
        "address": "Adresse",
        "phonenumber": "Numéro De Téléphone"
      },
      "contract_email": {
        "title": "Coordonnées",
        "field": "Adresse E-mail"
      }
    },
    "step_2": {
      "basic_information": {
        "title": "Votre Événement",
        "description_header": "",
        "description": "Veuillez sélectionner les jours pendant lesquels se déroule votre événement. Vous pouvez sélectionner plusieurs jours et modifier les détails pour chaque jour.",
        "fields": {
          "event_name": "Nom de l'événement",
          "event_type": "Type d'événement",
          "number_of_guests": "Nombre d'invités",
          "start_time": "Heure de début",
          "end_time": "Heure de fin",
          "amount": "Quantité",
          "total": "Total",
          "add": "Ajouter",
          "emplacement": "Disposition"
        }
      },
      "add_day": {
        "title": "Voulez-Vous Ajouter Un Autre Jour?",
        "add_day": "Ajouter Un Jour",
        "add_item": "Ajouter Un Produit",
        "day": "Jour {dayCount}",
        "date": "Date",
        "select_date": "Sélectionner Une Date",
        "select_date_description": "C'est le {day} de votre événement. Vous pouvez modifier les détails pour ce jour ci-dessous.",
        "plenary_hall": "Salle Plénière",
        "sub_hall": "Salle Annexe",
        "add_hall_description": "Pour ajouter d'autres espaces de réception à ce jour, cliquez sur le bouton d'ajout d'espace",
        "add_hall_required": "Comme votre forfait n'inclut pas d'espace de fonction, vous devez en ajouter au moins un",
        "add_hall_required_error": "Veuillez ajouter au moins un espace de fonction pour continuer",
        "add_hall_button": "Ajouter Un Espace",
        "package_deal": "Packages Disponibles",
        "package_deal_chosen": "Package Sélectionné",
        "package_deal_available": "Packages Disponibles",
        "package_deal_items": "Articles Supplémentaires",
        "package_deal_items_included": "Voir Les Articles Inclus",
        "package_deal_spaces_included": "Espaces inclus",
        "additional_items": "Articles Supplémentaires",
        "search": "Rechercher",
        "no_items_found": "Aucun produit trouvé",
        "choose_package_deal": "Choisir",
        "deselect_package_deal": "Supprimer"
      },
      "remarks": {
        "title": "Remarques"
      },
      "item_types": {
        "audiovisual": "Audiovisuel",
        "food_beverage": "Nourriture Et Boissons",
        "other": "Autre"
      },
      "item_examples": {
        "audiovisual": "Par exemple: microphones",
        "food_beverage": "Par exemple: collations",
        "other": "Par exemple: fleurs"
      },
      "clone_day": "Cloner Le Jour",
      "space_selector": {
        "show_spaces": "Choisissez Un Espace",
        "hide_spaces": "Cacher Les Espaces",
        "no_selection": "Nous sélectionnerons un espace adapté pour vous en fonction des informations ci-dessus.",
        "capacities": "Capacité par disposition",
        "space_not_available": "Non disponible",
        "space_already_selected": "Déjà sélectionné",
        "space_selected": "Sélectionné",
        "select_space": "Sélectionner",
        "show_more": "Afficher Plus D'Espaces",
        "show_less": "Afficher Moins D'Espaces",
        "show_unavailable": "Afficher les espaces non disponibles",
        "hide_unavailable": "Masquer les espaces non disponibles",
        "unavailable_matching_spaces": "Espaces qui correspondent à vos exigences mais qui ne sont pas disponibles",
        "no_image": "Aucune photo disponible"
      }
    },
    "step_3": {
      "booking": {
        "title": "Chambres",
        "title_with_date": "Chambres pour {date}",
        "available": "Disponible",
        "unavailable": "Indisponible",
        "available_rooms": "{n} disponible",
        "quantity": "Quantité",
        "guests_per_room": "Invités par chambre",
        "guests_per_room_with_max": "Invités par chambre (max {max})",
        "max_guests": "Max {n} invités",
        "fields": {
          "name": "Nom du groupe",
          "check_in_date": "Arrivée",
          "check_out_date": "Départ",
          "property": "Établissement pour Chambres",
          "number_of_rooms": "Quantité",
          "persons_per_room": "Invités par chambre",
          "total_guests": "Nombre total d'invités",
          "room_type": "Type de chambre",
          "late_check_out": "Départ tardif",
          "late_check_out_rooms": "Chambres en départ tardif",
          "breakfast": "Petit-déjeuner",
          "remarks": "Remarques"
        },
        "progress_selected": "Sélectionné",
        "max_capacity": "Max {count} invités",
        "sections": {
          "property": "Sélection de Propriété",
          "details": "Détails de Réservation", 
          "room_selection": "Sélection de Chambre"
        },
        "collapsed_summary": "{selected}/{total} chambres sélectionnées pour {date}",
        "completed": "Terminé",
        "too_many_selected": "Trop sélectionnées",
        "incomplete": "Incomplet"
      },
      "overnight_stay": {
        "title": "Voulez-Vous Ajouter Une Autre Nuitée ?",
        "button": "Ajouter Une Nuitée",
        "day": "Nuitée"
      },
      "clone_room": "Cloner La Nuitée"
    },
    "step_4": {
      "account_details": {
        "title": "Informations Sur Le Compte",
        "fields": {
          "first_name": "Prénom",
          "last_name": "Nom de famille",
          "company_name": "Société",
          "email_address": "Adresse e-mail",
          "phone_number": "Numéro de téléphone"
        }
      },
      "billing_address": {
        "title": "Adresse De Facturation",
        "fields": {
          "address": "Adresse",
          "postal_code": "Code postal",
          "city": "Ville",
          "country": "Pays"
        }
      },
      "contact_person_location": {
        "title": "Personne De Contact Sur Place",
        "fields": {
          "copy": "Copier Depuis Les Informations Du Compte"
        }
      },
      "discount_code": "Code promo",
      "invoice_reference": "Référence de facture"
    },
    "step_5": {
      "offer": "Votre Offre",
      "reservation": "Votre Réservation",
      "request": "Votre Réservation",
      "offer_details": "Vous pouvez vérifier tous les détails ici. Consultez également les suggestions que nous avons sélectionnées pour vous en fonction de notre expertise.",
      "download_pdf": "Télécharger Le PDF",
      "hotel_only_meeting": "Séjour",
      "discount": "Remise",
      "remarks": "Remarques",
      "payment_method": "Mode De Paiement",
      "payment_done": "Paiement Réussi",
      "payment_succeeded": "Votre réservation a été effectuée. Nous vous enverrons un e-mail avec vos détails.",
      "payment_waiting": "Traitement Du Paiement",
      "payment_processing": "Votre paiement est en cours de traitement. Nous vous enverrons un e-mail dès que votre paiement sera approuvé.",
      "payment_failed": "Échec Du Paiement",
      "payment_failed_message": "Une erreur s'est produite lors du traitement de votre paiement. Veuillez réessayer.",
      "sub_total_exclusive_vat": "Sous-Total (Hors TVA)",
      "sub_total_exclusive_sales_tax": "Sous-Total (Hors Taxe De Vente)",
      "vat_amount": "{vat}% TVA",
      "sales_tax_amount": "{vat}% Taxe De Vente",
      "terms_and_conditions": "Conditions Générales",
      "minutes_left": "Votre demande sera réservée pendant 1 minute de plus. Veuillez finaliser votre paiement rapidement pour la sécuriser. | Votre demande sera réservée pendant <strong>{count} minutes</strong> de plus. Veuillez finaliser votre paiement rapidement pour la sécuriser.",
      "seconds_left": "Il vous reste <strong>1 seconde</strong> pour finaliser votre paiement. Votre demande expirera bientôt. | Il vous reste <strong>{count} secondes</strong> pour finaliser votre paiement. Votre demande expirera bientôt.",
      "timer": {
        "title": "Temps Écoulé",
        "subtitle": "Désolé, le temps pour finaliser votre paiement est écoulé. Ne vous inquiétez pas, nous avons enregistré votre demande et nous vous contacterons dès que possible."
      },
      "basic_information": {
        "title": "Détails de la Réservation",
        "event_name": "Nom de l'événement",
        "event_type": "Type d'événement"
      },
      "contact_information": {
        "title": "Informations De Contact",
        "contact_person_location": "Personne De Contact Sur Place",
        "account_details": "Informations sur le compte",
        "billing_address": "Adresse de facturation"
      },
      "day": {
        "day": "Jour {dayCount}",
        "function_spaces": "Espaces événementiels",
        "additional_function_spaces": "Espaces événementiels supplémentaires",
        "pax": "Nombre d'invités",
        "emplacement": "Disposition",
        "start_time": "Heure De Début",
        "end_time": "Heure De Fin",
        "package_deals": "Packages",
        "package_deals_details": "Le package prêt pour vous avec les articles associés.",
        "package_deals_amount": "1 Personne | {count} Personnes",
        "package_deals_price": "{amount} Par Personne",
        "additional_items": "Articles Supplémentaires",
        "total": "Total",
        "vat": "TVA Incluse",
        "sales_tax": "Hors Taxe De Vente",
        "hall_rental": {
          "title": "Location D'Espace",
          "pax": "{pax} Personnes"
        }
      },
      "hotel_room": {
        "title": "Chambres",
        "price": "Prix",
        "room_type": "Type de chambre",
        "rooms": "Chambres",
        "number_of_rooms": "0 Chambres | 1 Chambre | {n} Chambres",
        "per_room": "Invités par chambre",
        "pax_room": "0 Personne Par Chambre | 1 Personne Par Chambre | {n} Personnes Par Chambre",
        "breakfast_status": "Petit-déjeuner inclus | Petit-déjeuner non inclus",
        "late_checkout": "Late Check-out",
        "nights": "0 Nuit | 1 Nuit | {n} Nuits",
        "per_night": "{amount} Par Chambre Par Nuit",
        "breakfast_price": "{name}: {amount} Par Personne Par Nuit",
        "late_checkout_price": "Late Check-out: {amount} Par Chambre",
        "city_tax": "Hors Taxe De Séjour",
        "guests": "Invités",
        "number_of_guests": "0 Invité | 1 Invité | {n} Invités"
      },
      "multi_venue_alert": {
        "title": "Réservation multi-sites",
        "description": "Chambres réservées dans d'autres établissements. Voir détails ci-dessous."
      }    },

    "modal": {
      "confirm_turn_down": {
        "title": "Êtes-Vous Sûr De Vouloir Refuser Cette Offre ?",
        "body": "Cette action est irréversible.",
        "checkbox": "J'accepte de refuser cette offre de manière irrévocable."
      },
      "confirm_cancel": {
        "title": "Êtes-Vous Sûr De Vouloir Annuler Cette Réservation ?",
        "body": "Les conditions générales s'appliquent.",
        "checkbox": "J'ai lu, compris et j'accepte les <a href='{termsUrl}' target='_blank'>conditions générales</a>."
      },
      "confirm_accept": {
        "title": "Confirmez Votre Réservation",
        "body": "Les conditions générales s'appliquent.",
        "checkbox": "J'ai lu, compris et j'accepte les <a href='{termsUrl}' target='_blank'>conditions générales</a>."
      },
      "reservation_edited": {
        "title": "Merci Beaucoup. Vos Modifications Ont Été Appliquées."
      },
      "reservation_submitted": {
        "title": "Merci Beaucoup. C'est Formidable De Voir Votre Intérêt Pour L'Organisation De Votre {meeting} Chez Nous.",
        "body": "Vous recevrez une offre pour votre réservation dès que possible.",
        "button": "Cliquez ici pour visiter le site web de {locationName}"
      },
      "reservation_accepted": {
        "body": "Vous recevrez une confirmation de votre réservation dès que possible."
      },
      "reservation_cancelled": {
        "title": "Vous Avez Annulé La Réservation Pour Votre {meeting}."
      },
      "reservation_turned_down": {
        "title": "Vous Avez Refusé L'Offre Pour Votre {meeting}."
      },
      "cancel_reason": {
        "text": "Raison Pour L'Annulation",
        "placeholder": "Veuillez préciser la raison de l'annulation de cette réservation."
      },
      "turn_down_reason": {
        "text": "Raison Du Refus",
        "placeholder": "Veuillez préciser la raison de votre refus de cette offre."
      },
      "submitting": {
        "title": "Nous Soumettons Votre Demande",
        "subtitle": "Cela peut prendre un certain temps. Veuillez ne pas fermer cette fenêtre."
      },
      "request": {
        "loading_title": "Nous Créons Votre Réservation Optionnelle",
        "submitted_text": "Vous recevrez une offre pour votre réservation dès que possible."
      },
      "inquire": {
        "loading_title": "Nous Créons Votre Demande De Renseignements",
        "submitted_text": "Nous vous contacterons dès que possible."
      },
      "book": {
        "loading_title": "Nous Calculons Le Prix",
        "submitted_text": ""
      }
    },
    "buttons": {
      "edit_reservation": "Modifier La Réservation",
      "save_pdf": "Enregistrer L'Offre En PDF",
      "submit_offer": "Demander Une Offre",
      "next_step": "Étape Suivante",
      "previous_step": "Étape Précédente",
      "accept_offer": "Accepter L'Offre",
      "cancel_offer": "Annuler La Réservation",
      "turn_down_offer": "Refuser L'Offre",
      "edit_offer": "Appliquer Les Modifications",
      "request_proposal": "Demander Une Proposition",
      "request": "Demander Une Proposition",
      "inquire": "Demander Des Informations",
      "book": "Réserver Maintenant",
      "accept_booking": "Confirmer La Réservation",
      "pay_booking": "Payer",
      "cancel_booking": "Annuler La Réservation"
    },
    "basket": {
      "cart": "Aperçu des prix",
      "event": "Événement",
      "hotel_rooms": "Chambres",
      "estimated_fees": "Frais estimés",
    "event_subtotal": "Sous-total événement",
    "hotel_room_subtotal": "Sous-total chambres",
      "guests": "invités",
      "meeting_space": "Salle de réunion",
      "additional_services": "Services supplémentaires",
      "room": "chambre",
      "rooms": "chambres",
      "tax_breakdown": "Détail des taxes",
      "subtotal_with_rate": "Sous-total ({rate}% TVA)",
      "vat_with_rate": "TVA ({rate}%)",
      "sales_tax_with_rate": "Taxe de vente ({rate}%)",
      "total_excluding_tax": "Total hors TVA",
      "total_excluding_sales_tax": "Total hors taxe de vente",
      "total_tax": "Total TVA",
      "total_sales_tax": "Total taxe de vente",
      "total_including_taxes": "Total TTC",
      "total_including_sales_taxes": "Total taxes de vente incluses",
      "empty_cart": "Ajoutez des éléments à votre réservation pour voir les détails des prix.",
      "pricing_unavailable": "L'aperçu des prix n'est pas disponible pour cette réservation. Vous recevrez des informations détaillées sur les prix après avoir terminé votre demande de réservation."
    }
  },
  "dropdown": {
    "no_results": "Aucun Résultat Trouvé",
    "placeholder": "Sélectionner Une Option",
    "loading": "Chargement..."
  },
  "switch": {
    "yes": "Oui",
    "no": "Non"
  },
  "enums": {
    "payment_method": {
      "AT_LOCATION": "Sur Place",
      "CREDIT_CARD": "Carte De Crédit",
      "INVOICE": "Facture",
      "PRE_PAYMENT": "Pré-Paiement",
      "VOUCHER": "Bon"
    }
  },
  "price_types": {
    "per_guest": "Par Invité",
    "per_unit": "Par Unité",
    "per_guest_explanation": "{price} par invité",
    "per_unit_explanation": "{price} prix fixe"
  }
}